import React from 'react'
import globeIcon from '../../../../assets/globe.png'

import { StyledButton, ImgContainer } from './styles'

const FilterDropdownButton = ({ onClick, countBadge, ...rest }) => {
  return (
    <StyledButton primary type="button" onClick={onClick} {...rest}>
      <ImgContainer>
        <img src={globeIcon} alt="Globe icon" />
      </ImgContainer>
      {countBadge}
    </StyledButton>
  )
}

export default FilterDropdownButton
